import { Component } from '@angular/core'

import { IonicPage, NavController, NavParams, ToastController, ItemSliding } from 'ionic-angular'
import { AlertController } from 'ionic-angular'

import { debounceTime } from 'rxjs/operators/debounceTime'

import { Condominium, HousingUnit, User } from '../../models/models'

import { UserProvider } from '../../providers/user/user'
import { AuthProvider } from '../../providers/auth/auth'

import { UserEditPage } from '../../pages/user-edit/user-edit'
import { UserShowPage } from '../../pages/user-show/user-show'
import { UserAddPage } from '../../pages/user-add/user-add'

import { FormControl } from '@angular/forms'
import { ControlPanelPage } from '../control-panel/control-panel'

@IonicPage()
@Component({
	selector: 'page-user-index',
	templateUrl: 'user-index.html',
})
export class UserIndexPage {
	/*
	Se non null indica il condominio di riferimento
	*/
	public condominium: Condominium = null;
	public housingUnit: HousingUnit = null;
	public isLoading = true;
	public searchTerm: string

	public searchControl: FormControl

	public allUsers: Array<User> = [];
	public administrators: Array<User> = [];
	public admins: Array<User> = [];
	public operators: Array<User> = [];
	public heatingreaders: Array<User> = [];
	public workers: Array<User> = [];
	public others: Array<User> = [];

	public allUsersExpanded: boolean = false;
	public othersExpanded: boolean = false;

	public itemSliding: ItemSliding = null;

	/*
	salva l'eventuale condominio di riferimento
	*/
	constructor(
		public alertCtrl: AlertController,
		public users: UserProvider,
		public nav: NavController,
		public navParams: NavParams,
		public toastCtrl: ToastController,
		public auth: AuthProvider
	) {
		this.condominium = navParams.get('condominium')
		this.housingUnit = navParams.get('housingUnit')
		this.searchControl = new FormControl()
	}
	public goToControlPanel() {
		this.nav.setRoot(ControlPanelPage)
	}

	goToUserAdd(permission: string = null) {
		let options = {}
		if(permission) {
			options['is_' + permission] = true
		}
		this.nav.push(UserAddPage, options)
	}

	goToUserEdit(menu, user: User) {
		menu.close()
		this.nav.push(UserEditPage, { user: user })
	}

	goToUserShow(menu, user: User) {
		menu.close()
		this.nav.push(UserShowPage, { user: user })
	}

	/*
	Quando il DOM ha finito di caricare
	*/
	ionViewDidLoad() {
		let self = this

		this.searchControl.valueChanges
			.pipe(debounceTime(1000))
			.subscribe(search => {//quando cambia i termini di ricerca aspetta X millisecondi prima di fare un caricamento da web
				console.log("Filtro utenti: " + search)
				self.refresh()
			})
	}

	/*
	quando sta per visualizzare o rivisualizzare la pagina
	*/
	ionViewWillEnter() {
		this.refresh()//Quando visualizza la pagina aggiorna gli utenti
	}

	/*
	quando cambiano i termini della ricerca
	*/
	onSearchInput() {//Quando cambia i termini di ricerca va immediatamente in loading
		this.isLoading = true
	}

	refresh() {
		console.log('Refresh elenco utenti..')
		let self = this
		this.isLoading = true
		self.administrators = []
		self.admins = []
		self.operators = []
		self.heatingreaders = []
		self.workers = []
		self.others = []
		self.allUsers = []

		let loads = []
		//admin vedono account identifier
		if(this.auth.hasRole(['is_admin', 'is_operator'])) {
			loads.push('accounts')
		}
		this.users.index(this.condominium, this.housingUnit, loads, undefined, this.searchTerm)
			.then((users: Array<User>) => {
				if(users) {
					self.allUsers = users

					for(let i in users) {
						let d = users[i]
						if(d.is_admin) {
							self.admins.push(d)
						}
						if(d.is_operator) {
							self.operators.push(d)
						}
						if(d.is_heatingreader) {
							self.heatingreaders.push(d)
						}
						if(d.is_administrator) {
							self.administrators.push(d)
						}
						if(d.is_worker) {
							self.workers.push(d)
						}
						//se non è nulla va nell'elenco di chi non ha privilegi
						if(
							!d.is_admin
							&& !d.is_operator
							&& !d.is_heatingreader
							&& !d.is_administrator
							&& !d.is_worker
						) {
							self.others.push(d)
						}
					}
				} else {
					let toast = self.toastCtrl.create({
						message: 'Potrebbe essersi verificato un errore recuperando gli utenti',
						position: 'middle',
						duration: 3000,
						cssClass: "danger"
					})
					toast.present()
				}

				self.isLoading = false
			}).catch(error => {
				let toast = self.toastCtrl.create({
					message: 'Errore recuperando gli utenti',
					position: 'middle',
					duration: 3000,
					cssClass: "danger"
				})
				toast.present()
				console.error('Errore recuperando gli utenti:', error)
				self.isLoading = false
			})
	}

	showDestroyUserConfirm(menu, user) {
		menu.close()
		let self = this
		let confirm = this.alertCtrl.create({
			title: "Eliminare l'utente dal server?",
			message: "Vuoi davvero eliminare l'utente '" + user.name + " " + user.surname + "' - " + user.fiscal_code + " " + user.vat_number + "?",
			buttons: [
				{
					text: 'Annulla',
					role: 'cancel'
				}, {
					text: 'Elimina',
					handler: () => {
						self.users.destroy(user).then((success: boolean) => {
							if(success) {
								let toast = self.toastCtrl.create({
									message: 'Utente eliminato',
									position: 'middle',
									duration: 3000,
									cssClass: "light"
								})
								toast.present()
							} else {
								let toast = self.toastCtrl.create({
									message: "Potrebbe essersi verificato un errore eliminando l'utente",
									position: 'middle',
									duration: 3000,
									cssClass: "danger"
								})
								toast.present()
							}
							this.refresh()
						}).catch(error => {
							console.error("Errore cancellando l'utente", error)
							let toast = self.toastCtrl.create({
								message: "Errore cancellando l'utente",
								position: 'middle',
								duration: 3000,
								cssClass: "danger"
							})
							toast.present()
							this.refresh()
						})
					}
				}
			]
		})
		confirm.present()
	}

	showRemoveRoleConfirm(closable, user: User, role: string) {
		closable.close()
		let self = this
		let confirm = this.alertCtrl.create({
			title: "Rimuovere il ruolo all'utente?",
			message: "Vuoi davvero rimuovere il ruolo all'utente '" + user.name + " " + user.surname + "' - " + user.fiscal_code + " " + user.vat_number + "?",
			buttons: [
				{
					text: 'Annulla',
					role: 'cancel'
				}, {
					text: 'Rimuovi',
					handler: () => {
						user[role] = false
						self.users.update(user).then((user: User) => {
							if(user && !user[role]) {
								let toast = self.toastCtrl.create({
									message: 'Ruolo rimosso',
									position: 'middle',
									duration: 3000,
									cssClass: "light"
								})
								toast.present()
							} else {
								let toast = self.toastCtrl.create({
									message: "Potrebbe essersi verificato un errore rimuovendo il ruolo",
									position: 'middle',
									duration: 3000,
									cssClass: "danger"
								})
								toast.present()
							}
							this.refresh()
						}).catch(error => {
							console.error("Errore rimuovendo il ruolo", error)
							let toast = self.toastCtrl.create({
								message: "Errore rimuovendo il ruolo",
								position: 'middle',
								duration: 3000,
								cssClass: "danger"
							})
							toast.present()
							this.refresh()
						})
					}
				}
			]
		})
		confirm.present()
	}
	/*
	public slide(itemSlide:ItemSliding){
	if(this.itemSliding){ //use this if only one active sliding item allowed
	this.itemSliding.close();
	this.itemSliding=null;
	}

	if(itemSlide){
	if(itemSlide.getSlidingPercent()==0) {
	this.itemSliding=itemSlide;

	let swipeAmount=-256; //set your required swipe amount
	itemSlide.startSliding(swipeAmount);
	itemSlide.moveSliding(swipeAmount);
	itemSlide.moveSliding(swipeAmount);

	itemSlide.setElementClass('active-options-right', true);
	itemSlide.setElementClass('active-swipe-right', true);

	//item.setElementStyle('transition', null);
	//item.setElementStyle('transform', 'translate3d(-'+swipeAmount+'px, 0px, 0px)');

	// Two calls intentional after examination of vendor.js function
	//itemSlide.startSliding(64);
	/*
	itemSlide.moveSliding(-256);
	itemSlide.moveSliding(-256);
	* /
	//itemSlide.endSliding(1);
	//itemSlide.moveSliding(-400);
	}else{
	itemSlide.close();
	}
	}
	}
	*/
}



// WEBPACK FOOTER //
// ./src/pages/user-index/user-index.ts